module.exports = __webpack_public_path__ + "img/star_room.794ea114.png";